import _ from 'underscore';
import Localizer from 'localizer';
import Backbone from 'backbone';
import templateHtml from 'views/gdpr/templates/gdprModalFooter.html';

var Events = {
    DONT_SHOW_AGAIN: 'DONT_SHOW_AGAIN',
    CANCEL_MODAL: 'CANCEL_MODAL'
};

var GdprModalFooterView = Backbone.View.extend({
    template: _.template(templateHtml),

    events: {
        'click .js-middleBtn': 'onDontShowAgainClicked',
        'click .js-cancel': 'onCancelClicked',
        'click .js-close': 'onCancelClicked'
    },

    initialize: function(args) {
        this.cancelBtn = args.cancelBtn;
        this.showMiddleBtn = args.showMiddleBtn;
        this.middleBtn = args.middleBtn;
        this.saveBtn = args.saveBtn;
        this.showFooterLink = args.showFooterLink;
        this.footerTextLink = args.footerTextLink;
        this.footerLink = args.footerLink;
    },

    render: function() {
        this.$el.html(
            this.template({
                Localizer: Localizer,
                cancelBtn: this.cancelBtn,
                showMiddleBtn: this.middleBtn ? '' : 'hidden',
                middleBtn: this.middleBtn,
                saveBtn: this.saveBtn,
                showFooterLink: this.footerTextLink ? '' : 'hidden',
                footerTextLink: this.footerTextLink,
                footerLink: this.footerLink
            })
        );
    },

    onDontShowAgainClicked: function() {
        this.trigger(Events.DONT_SHOW_AGAIN);
    },

    onCancelClicked: function() {
        this.trigger(Events.CANCEL_MODAL);
    }
});

GdprModalFooterView.Events = Events;

export default GdprModalFooterView;
